import { doc } from 'firebase/firestore';

import { SystemConfig } from '@superfunnel/types/system-config';

import { db } from '../Firebase';
import { emptyConverter } from '../utils';

/**
 * Get a reference to the system config document.
 * Document path: system/config
 */
export const getSystemConfigDocRef = () =>
  doc(db, 'system', 'config').withConverter(emptyConverter<SystemConfig>());
